import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "src/components/Displays/PageTitle";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import { SMART_CHARGING_PATHS } from "src/consts/Routes/SmartCharging";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import VerticalLinearProgress from "src/components/ProgressBar/VerticalLinearProgressBar";

export const pathCalculator = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.OVERVIEW_START:
      return 0;
    case SMART_CHARGING_ROUTES.OVERVIEW_DETAILS:
      return 55;
    default:
      return 20;
  }
};

const SmartChargingOverviewProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SMART_CHARGING_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={55 - pathCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Overview"} />
            <PageSubTitle text={"Verbundene Geräte"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SmartChargingOverviewProgressBar;
